var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-footer"},[_c('div',{staticClass:"code"},[_c('img',{attrs:{"src":require("../assets/banner_1.jpeg")}})]),_c('div',{staticClass:"info"},[_c('div',[_vm._v("云南省归国华侨联合会 版权所有 Copyright2004")]),_c('div',[_vm._v("地址：云南省昆明市五华区云南省昆明市五华区云南省昆明市五华区")])])])
}]

export { render, staticRenderFns }